import React, { useEffect, useState } from 'react';
import { Spin, Tabs } from 'antd';

import useWizardSteps from 'hooks/useWizardSteps';
import { TabsProps } from 'antd/lib/tabs';
import { isNil, sortBy } from 'lodash';

const { TabPane } = Tabs;

export type WizardTabsProps = TabsProps & {
  defaultTabs?: string[];
  entity: string;
  entityid?: number;
  hiddenTabs?: string[];
  tabs: Record<string, React.ReactElement>;
  taskid?: number;
  tabPosition?: string;
  disabled?: any;
  className?: string;
};

const WizardTabs = ({
  defaultTabs,
  entity,
  entityid,
  hiddenTabs,
  tabs,
  taskid,
  tabPosition,
  disabled,
  className,
  ...otherProps
}: WizardTabsProps) => {
  const steps = useWizardSteps({ entity, entityid, taskid }, defaultTabs);
  const filteredSteps = hiddenTabs
    ? steps?.filter((step) =>
      step.funcode ? !hiddenTabs.includes(step.funcode) : true
    )
    : steps;

  const tabPositionFinal =
    tabPosition ?? (localStorage.getItem('tabposition') as any);

  const sortedSteps = sortBy(filteredSteps, 'steporder');

  const [activeKey, setActiveKey] = useState<string>();
  useEffect(() => {
    if (sortedSteps?.length && !activeKey) {
      setActiveKey(sortedSteps[0].funcode);
    }
  }, [sortedSteps]);

  return (
    <Spin
      spinning={isNil(steps)}
      size="default"
      style={{
        position: 'fixed',
        top: '40%',
      }}
    >
      <Tabs
        {...otherProps}
        activeKey={activeKey}
        onChange={setActiveKey}
        tabPosition={tabPositionFinal ?? 'left'}
        type="line"
        className={className ?? ''}
        style={{ padding: '10 80 80 10' }}
      >
        {sortedSteps?.map((step, index) => {
          const funcode = step.funcode ?? '';
          const tabComponent = tabs[funcode];

          return (
            <TabPane
              tab={step.steplabel}
              key={funcode}
              disabled={disabled}
              forceRender
            >
              {React.cloneElement(tabComponent, {
                step,
                index,
                isActive: activeKey === funcode,
              })}
            </TabPane>
          );
        })}
      </Tabs>
    </Spin>
  );
};

export default WizardTabs;
